import loggerGenerator from '@travel/logger';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { apiPath } from 'constants/api';

import type { ApiClient } from '@travel/api-client';
import type { UserProfile } from '../apiTypes';
import { noticeError } from '@travel/tracker';

const logger = loggerGenerator();

export const fetchProfileById = createAsyncThunk<
  UserProfile,
  string,
  { extra: { apiClient: ApiClient } }
>('profileById/fetch', async (payload, { extra: { apiClient }, rejectWithValue }) => {
  try {
    const data = await apiClient.get(apiPath.profileById.pathname(payload));

    return data;
  } catch (error) {
    logger.error('Fetch Profile By Id Failed', error);
    noticeError('Fetch Profile By Id Failed', error);

    return rejectWithValue(error);
  }
});
